const React = require('react');

const {paramStore} = require("../../../../stores");
const withState = require("../../../../utils/withState");
const {AdminPageHeader} = require("../../../dumb/AdminHelpers/AdminLayout");
const SecondLayerMenu = require("../../../dumb/AdminHelpers/AdminLayout/components/SecondLayerMenu");

const MerchantFlow = require('./components/MerchantFlow');
const OnrampFlow = require('./components/OnrampFlow');

const tabs$ = paramStore('configTypes', 'merchant');

module.exports = withState(() => {
  return ({configType = merchant}) => {
    const links = [
      {
        id: 'merchant',
        title: 'Merchant flow'
      },
      {
        id: 'onramp',
        title: 'Onramp flow'
      }
    ];

    const components = {
      merchant: MerchantFlow,
      onramp: OnrampFlow,
    }

    const Component = components[configType];

    return (
      <>
        <AdminPageHeader title="Global Rules" />
        <div className="mt30">
          <SecondLayerMenu
            emitter={tabs$}
            onChange={() => {
              paramStore('config').emit();
            }}
            links={links}
          />
        </div>
        <div className="mt34">
          <Component />
        </div>
      </>
    )
  }
}, {
  configType: tabs$
})
